// src/slices/configSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Config } from '../types/config';
import defaultConfig from '../config/defaultConfig';
import { ThemeType, themeIds } from '../assets/themeConfig';

interface ConfigState {
    activeConfig: Config | null;
    theme: ThemeType;
}

// 🔁 Funktion zum initialen Theme (aus localStorage oder zufällig)
function getInitialTheme(): ThemeType {
    const stored = localStorage.getItem('theme');
    if (stored && themeIds.includes(stored as ThemeType)) {
        return stored as ThemeType;
    }

    const randomIndex = Math.floor(Math.random() * themeIds.length);
    return themeIds[randomIndex];
}

const initialState: ConfigState = {
    activeConfig: null,
    theme: getInitialTheme(),
};

const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {
        setActiveConfig: (state, action: PayloadAction<Config>) => {
            state.activeConfig = action.payload;
        },
        setTheme: (state, action: PayloadAction<ThemeType>) => {
            state.theme = action.payload;
            localStorage.setItem('theme', action.payload); // ✅ speichern
        },
        loadDefaultConfig: (state) => {
            state.activeConfig = defaultConfig;
        },
    },
});

export const { setActiveConfig, setTheme, loadDefaultConfig } = configSlice.actions;
export default configSlice.reducer;
